import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { first } from 'rxjs';
import { SessionService } from 'src/app/services/session.service';
import { BaseWizardComponent } from '../base-wizard.component';
import { ILandholderConfirmationModel } from '../models/veg-wizard-models';
import { VegWizardDataService } from '../services/veg-wizard-data.service';

@UntilDestroy()
@Component({
  selector: 'app-landholder-confirmation',
  templateUrl: './landholder-confirmation.component.html',
  styleUrls: ['./landholder-confirmation.component.css'],
  imports: [
    ReactiveFormsModule
],
})
export class LandholderConfirmationComponent extends BaseWizardComponent implements OnInit {

  form: FormGroup;
  landholderConfirmationData: ILandholderConfirmationModel | undefined;
  isAllowedToContinue = false;

  public get areYouTheLandholder(): boolean {
    return this.form.controls['areYouTheLandholder'].value;
  }

  public get areYouAuthorised(): boolean {
    return this.form.controls['areYouAuthorised'].value;
  }

  public get areYouLandsOfficer(): boolean {
    return this.form.controls['areYouLandsOfficer'].value;
  }

  constructor(
    private formBuilder: FormBuilder,
    private vwds: VegWizardDataService,
    private sessionService: SessionService,
    router: Router) {
    super();

    this.landholderConfirmationData = this.vwds.getLandholderConfirmationModel();

    this.form = this.formBuilder.group({
      areYouTheLandholder: [this.landholderConfirmationData?.areYouTheLandholder, Validators.required],
      areYouAuthorised: [this.landholderConfirmationData?.areYouAuthorised, Validators.required],
      areYouLandsOfficer: [this.landholderConfirmationData?.areYouLandsOfficer, Validators.required]
    });

  }

  ngOnInit(): void {

    // ensure we have a sessionKey id when we are on this page
    this.sessionService.startOrGetSessionId$()
      .pipe(first(), untilDestroyed(this))
      .subscribe();

    this.performValidation();

    this.form.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
      this.performValidation();
    });
  }

  private performValidation() {
    if (this.areYouTheLandholder) {
      this.isAllowedToContinue = true;
    }
    else if (this.areYouAuthorised && this.areYouLandsOfficer != null) {
      this.isAllowedToContinue = true;
    }
    else {
      this.isAllowedToContinue = false;
    }
  }

  override next(): void {
    this.vwds.setLandholderConfirmationModel$(this.form.getRawValue())
      .pipe(first(), untilDestroyed(this))
      .subscribe((success) => {
        if (success) {
          super.next();
        }
      });
  }

}
